export default "__VITE_ASSET__DwvUebgR__"